<template>
    <metainfo></metainfo>
    <div class="bg"></div>
    <NavBar/>

    <BlackLayoutForPopUp/>
    <TopLoadingBar/>

<!--    All View will not render unit API setting is done-->
    <div class="main" v-if="doneApiSetting">
        <router-view/>
    </div>

    <GoBackTopButton/>

</template>

<script>
import NavBar from "@/components/appComponents/NavBar";
import {useMeta} from 'vue-meta'
import TopLoadingBar from "@/components/appComponents/TopLoadingBar";
import BlackLayoutForPopUp from "@/components/appComponents/BlackLayoutForPopUp";
import GoBackTopButton from "@/components/appComponents/GoBackTopButton";

export default {
    components: {
        NavBar,
        TopLoadingBar,
        BlackLayoutForPopUp,
        GoBackTopButton,
    },
    data(){
        return{
            doneApiSetting: false
        }
    },
    watch: {
        '$route' () {
            this.getServerTokenAuth()
        }
    },
    async beforeCreate() {
        // InitializeStore when started
        this.$store.commit('initializeStore')
        this.$i18n.locale = this.$store.state.language
    },
    async mounted() {
        // Vue-Meta@Next, add this useMeta Function in App.js mounted()
        // Main.js add those import stuff
        // Upward on template, add this on top of everything <metainfo></metainfo>
        // import {useMeta} from 'vue-meta'
        useMeta({
            meta: [
                // { charset: 'utf-8' },
                // { name: 'viewport', content: 'width=device-width, initial-scale=1' },
                {name: 'mobile-web-app-capable', content: 'yes'},
                {name: 'apple-mobile-web-app-capable', content: 'yes'},
                {name: 'apple-mobile-web-app-status-bar-style', content: 'black'},
                {name: 'apple-mobile-web-app-title', content: 'Vue App'},
            ]
        })

        // Added in watch, better than place in mounted, cuz mounted will not render again if return
        // Don't add in beforeCreate, Global Functions aren't be initialized
        // await this.getServerTokenAuth()
    },
    methods: {
        async getServerTokenAuth(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.post('api/auth/', {
                "username": "client",
                "password": "P@ssw0rdF0rClient"
            })
                .then(async response => {
                    this.$store.commit("setServerToken")
                    this.$mainApi.defaults.headers.common['Authorization'] = "Token " + response.data.token;
                    this.$mainApi.defaults.headers.common['Accept-Language'] = this.$store.state.language;

                    await this.$mainApi.post('api/client/check/', {
                        "user_id": this.$store.state.userServerID,
                        "current_online_pk": this.$store.state.userOnlinePK,
                    })
                        .then(response => {
                            if (response.data.details === 80) {
                                // Check if user still login, set API headers here
                                // ** put in store will error cuz that time Axios is not created
                                if (this.$store.state.isAuthenticated === true) {
                                    this.$mainApi.defaults.headers.common['GL-User-ID'] = this.$store.state.userServerID;
                                    this.$mainApi.defaults.headers.common['GL-User-Online-ID'] = this.$store.state.userOnlinePK;
                                    this.$mainApi.defaults.headers.common['GL-Page-ID'] = "1";
                                    this.$mainApi.defaults.headers.common['GL-Action-ID'] = "1";
                                    console.log("Front & Back Connection Auth Done")
                                }
                            } else {
                                this.$store.commit('setUserLogout')
                                console.log("User Logged Out")
                                if(this.$router.currentRoute._value.name === 'system-license'){
                                    this.$router.push('/system/licence')
                                }else{
                                    this.$router.push('/login')
                                }
                            }
                        })

                    // // Check if user still login, set API headers here
                    // // ** put in store will error cuz that time Axios is not created
                    // if(this.$store.state.isAuthenticated === true){
                    //     this.$mainApi.defaults.headers.common['GL-User-ID'] = this.$store.state.userServerID;
                    //     this.$mainApi.defaults.headers.common['GL-User-Online-ID'] = this.$store.state.userOnlinePK;
                    //     this.$mainApi.defaults.headers.common['GL-Page-ID'] = "1";
                    //     this.$mainApi.defaults.headers.common['GL-Action-ID'] = "1";
                    //     console.log("User Data Added to Headers")
                    // }
                })

            // try{
            //     // Get something from server to let the login checker called on every page
            //     await this.$mainApi.post('api/client/check/' , {
            //         "user_id": this.$store.state.userServerID,
            //         "current_online_pk": this.$store.state.userOnlinePK,
            //     })
            //         .then(response => {})
            // }catch (e) {
            //     console.log('Logged Out')
            // }

            // ***IMPORTANT*** Add this Flag, so that All View will first run this Method Before it render
            this.doneApiSetting = true
            this.$store.commit('setIsTopLoading', false)
            this.$store.commit('setIsBlackLayout', false)
        },
    }
}

</script>

<!--tabulator css-->
<style src='tabulator-tables/dist/css/tabulator_bootstrap3.min.css'></style>
<!--npm install @vueform/multiselect-->
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss">

.tabulator-row.tabulator-selectable:hover {
    background-color: #bbb !important;
    cursor: pointer;
}

.tabulator-menu.tabulator-popup-container{
    top: 20px !important;
    position: fixed !important;
    overflow-y: scroll !important;
    height: auto !important;
    max-height: 50vh !important;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.main{
    padding-top: 5px;
}

.bg{
    z-index: -100;

    position: fixed;

    /* Full height */
    min-width: 100vw;
    min-height: 100vh;

    // Background Color
    background-color: #e5eeff;

    ///* The image used */
    // background-image: url('~@/assets/background.jpg');
    //
    ///* Center and scale the image nicely */
    //background-position: center;
    //background-repeat: no-repeat;
    //background-size: cover;
}

// ********************* Other Global CSS in here ****************************//
.error-text{
    color: red;
}

// show image in rapped mode
.rap-image{
    white-space:nowrap;
    overflow-x:auto;
}

</style>
